import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators, FormGroupDirective } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { SalesInformation, MerchantProfileSelectItem, MerchantAccount } from '../../../shared';
import { CardAcceptanceChannelValidator } from '../../validators';

@Component({
    selector: 'app-sales-information',
    templateUrl: './sales-information.component.html'
})
export class SalesInformationComponent implements OnInit {

    @Input() formGroupName: string;
    @Input() showErrors: boolean;
    @Output() onCardAcceptanceChannelChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    salesInformation: SalesInformation;
    salesInformationFormGroup: FormGroup;
    get estAnnualCreditCardSalesVol(): AbstractControl {
        return this.salesInformationFormGroup.get('estAnnualCreditCardSalesVol');
    }
    get estAvgTransactionAmt(): AbstractControl {
        return this.salesInformationFormGroup.get('estAvgTransactionAmt');
    }
    get cardAcceptanceChannels(): FormGroup {
        return this.salesInformationFormGroup.get('cardAcceptanceChannels') as FormGroup;
    }
    get inPersonCardAcceptanceChannel(): AbstractControl {
        return this.salesInformationFormGroup.get('cardAcceptanceChannels.inPersonCardAcceptanceChannel');
    }
    get mailTelephoneCardAcceptanceChannel(): AbstractControl {
        return this.salesInformationFormGroup.get('cardAcceptanceChannels.mailTelephoneCardAcceptanceChannel');
    }
    get websiteCommerceCardAcceptanceChannel(): AbstractControl {
        return this.salesInformationFormGroup.get('cardAcceptanceChannels.websiteCommerceCardAcceptanceChannel');
    }

    merchantProfiles: MerchantProfileSelectItem[];

    constructor(
        private readonly rootFormGroup: FormGroupDirective,
        private readonly fb: FormBuilder,
        private readonly route: ActivatedRoute
    ) {
    }

    ngOnInit() {
        this.route.data.subscribe(({ merchantAccount }: { merchantAccount: MerchantAccount }) => {
            this.salesInformation = merchantAccount.salesInformation;
            this.salesInformationFormGroup = this.rootFormGroup.control.get(this.formGroupName) as FormGroup;
            this.salesInformationFormGroup.addControl("estAnnualCreditCardSalesVol", this.fb.control(this.salesInformation.estAnnualCreditCardSalesVol, [Validators.required]));
            this.salesInformationFormGroup.addControl("estAvgTransactionAmt", this.fb.control(this.salesInformation.estAvgTransactionAmt, [Validators.required]));
            this.salesInformationFormGroup.addControl("cardAcceptanceChannels", this.fb.group({
                inPersonCardAcceptanceChannel: [this.salesInformation.inPersonCardAcceptanceChannel, [Validators.required]],
                mailTelephoneCardAcceptanceChannel: [this.salesInformation.mailTelephoneCardAcceptanceChannel, [Validators.required]],
                websiteCommerceCardAcceptanceChannel: [this.salesInformation.websiteCommerceCardAcceptanceChannel, [Validators.required]]
            }, { validators: [CardAcceptanceChannelValidator.equals100()] }));
            this.websiteCommerceCardAcceptanceChannel.valueChanges.subscribe((value: number) => {
                this.onCardAcceptanceChannelChange.emit(value * 1 === 0);
            });
        });
    }
}